import { render, staticRenderFns } from "./Outer.vue?vue&type=template&id=76267a16&scoped=true&"
import script from "./Outer.vue?vue&type=script&lang=js&"
export * from "./Outer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76267a16",
  null
  
)

export default component.exports